import { render, staticRenderFns } from "./GridIntroTwoSection.vue?vue&type=template&id=cddde0ba"
import script from "./GridIntroTwoSection.vue?vue&type=script&lang=ts"
export * from "./GridIntroTwoSection.vue?vue&type=script&lang=ts"
import style0 from "./GridIntroTwoSection.vue?vue&type=style&index=0&id=cddde0ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports